"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleAnalyticsService = void 0;
exports.GoogleAnalyticsService = {
    // https://developers.google.com/analytics/devguides/collection/gtagjs/pages
    pageview: (url) => {
        window.dataLayer.push({
            event: 'pageview',
            page: url,
        });
    },
    // https://developers.google.com/analytics/devguides/collection/gtagjs/events
    event: (dataLayer) => {
        window.dataLayer.push(dataLayer);
    },
};
